import {isLocalProfile} from '@web/core/config'

/** API mock 사용 여부 */
export const IS_MOCK = isLocalProfile && false

/** 주문 정보 복원 끄기 */
export const NO_STORAGE_ON_REFRESH = isLocalProfile && false

/** 개발환경 store 접근 여부 */
export const IS_AVAILABLE_LOCAL_STORE = isLocalProfile && false
